export const ApiFetchStatus = {
  LOADING: "loading",
  ERROR: "error",
  SUCCESS: "success",
};
